import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {OrdiniStat} from '../_models/_Index';
import {ArticoliStat} from '../_models/ArticoliStat';
import {environment} from '../../environments/environment';
import {ArticoloProduzioneStat} from '../_models/ArticoloProduzioneStat';
import {QualitaStatisticheStat} from '../_models/QualitaStatisticheStat';

@Injectable({ providedIn: 'root' })
export class StatisticheService {
  constructor(private http: HttpClient) {}

  /** `giornoLocale`: giorni e settimana nel fuso dell'organizzazione (dashboard iniziale, feature 161). */
  getStatistics(start: Date, end: Date, orgId: number, risorsaId: number, giornoLocale?: boolean) {
    return firstValueFrom(
      this.http.get<OrdiniStat>(`${environment.localApiUrl}api/Statistiche/GetOrdiniStatistiche?`
        + `start=${start.toUTCString()}&end=${end.toUTCString()}&orgId=${orgId}&risorsaId=${risorsaId}`
        + (giornoLocale === true ? '&giornoLocale=true' : ''))
    );
  }

  getArticoloStatistics(start: Date, end: Date, orgId: number, codice: string, risorsaId: number, lavorazioneId: number) {
    return firstValueFrom(
      this.http
        .get<ArticoliStat>(`${environment.localApiUrl}api/Statistiche/GetArticoloStatistiche?` +
          `start=${start.toUTCString()}&end=${end.toUTCString()}&orgId=${orgId}&codice=${codice}&`
          + `risorsaId=${risorsaId}&lavorazioneId=${lavorazioneId}`)
    );
  }

  getCommessaStatistics(start: Date, end: Date, orgId: number, codice: string, risorsaId: number, lavorazioneId: number) {
    return firstValueFrom(
      this.http
        .get<ArticoliStat>(`${environment.localApiUrl}api/Statistiche/GetCommessaStatistiche?`
          + `start=${start.toUTCString()}&end=${end.toUTCString()}&orgId=${orgId}&codice=${codice}&`
          + `risorsaId=${risorsaId}&lavorazioneId=${lavorazioneId}`)
    );
  }

  getArticoloProduzione(orgId: number, codice: string) {
    return firstValueFrom(
      this.http
        .get<ArticoloProduzioneStat[]>(`${environment.localApiUrl}api/Statistiche/GetArticoloProduzione?orgId=${orgId}&codice=${codice}`)
    );
  }

  getQualitaStatistiche(start: Date, end: Date, orgId: number) {
    return firstValueFrom(
      this.http.get<QualitaStatisticheStat>(`${environment.localApiUrl}api/Statistiche/GetQualitaStatistiche?`
        + `start=${start.toUTCString()}&end=${end.toUTCString()}&orgId=${orgId}`)
    );
  }
}
